import dayjs, { Dayjs } from 'dayjs';
import { DateTime } from 'luxon';
import { availabilitiesDenormalize } from '@docavenue/core';
import { Availability } from '@maiia/model/generated/model/api-patient/api-patient';
import { dayjsWithTimezone } from '../../../src/utils';
import { DEFAULT_TIMEZONE } from '../../../src/constants';

// TODO(@nampnq): Migrate dayjs to luxon because dayjs not support well timezone 🖕, asap
export const transform = (from: Dayjs, to: Dayjs, items: Availability[]) => {
  const checkSlot: Record<string, Set<string>> = {};
  const ret: { [k: string]: Availability[] } = {};
  const timezone = from?.$x?.$timezone || DEFAULT_TIMEZONE;
  const dayjsTZ = dayjsWithTimezone(timezone);
  // Fill slots by provide items
  for (const item of items) {
    const itemStartDate = DateTime.fromISO(item.startDateTime, {
      zone: timezone,
    });
    const timeSlot = itemStartDate.toFormat('HH:mm');
    const key = itemStartDate
      .startOf('day')
      .setZone('utc')
      .toISO();
    checkSlot[key] = checkSlot[key] || new Set();
    if (!checkSlot[key].has(timeSlot)) {
      checkSlot[key].add(timeSlot);
      ret[key] = ret[key] || [];
      ret[key].push(item);
    }
  }
  // Fill other by empty set
  const clonedTo = DateTime.fromISO(to.toISOString(), {
    zone: timezone,
  });
  let clonedFrom = DateTime.fromISO(from.toISOString(), {
    zone: timezone,
  }).startOf('day');
  while (clonedFrom < clonedTo) {
    const key = clonedFrom.setZone('utc').toISO();
    ret[key] = ret[key] || [];
    clonedFrom = clonedFrom.plus({ days: 1 });
  }
  // Convert to array
  return Object.entries(ret)
    .map(([k, v]) => ({
      date: dayjsTZ(k),
      slots: v,
      timezone,
    }))
    .sort((a, b) => a.date.diff(b.date));
};

export const getAvailabilities = (
  state: any,
  centerId: string,
  practitionerId: string,
) => {
  if (!state?.availabilities?.data?.cards) {
    return [];
  }
  const data = availabilitiesDenormalize(
    `${centerId}_${practitionerId}`,
    state?.availabilities?.data,
  );

  if (!data) {
    return [];
  }
  const { availabilities } = data;

  return availabilities;
};

export const getPreviousPeriod = (from: Dayjs) => {
  const currentTimezone = from?.$x?.$timezone || DEFAULT_TIMEZONE;
  const dayjsTZ = dayjsWithTimezone(currentTimezone);
  const newFrom = from
    .clone()
    .subtract(5, 'day')
    .startOf('day');
  const newTo = from
    .clone()
    .subtract(1, 'day')
    .endOf('day');
  return [dayjs.max(newFrom, dayjsTZ()), dayjs.max(newTo, dayjsTZ())];
};

export const getNextPeriod = (to: Dayjs) => {
  const currentTimezone = to?.$x?.$timezone || DEFAULT_TIMEZONE;
  const dayjsTZ = dayjsWithTimezone(currentTimezone);
  const newFrom = to
    .clone()
    .add(1, 'day')
    .startOf('day');
  const newTo = to
    .clone()
    .add(5, 'day')
    .endOf('day');

  return [dayjs.max(newFrom, dayjsTZ()), dayjs.max(newTo, dayjsTZ())];
};

export const getPeriod = (from: Dayjs) => {
  const newFrom = from.clone().startOf('day');
  const newTo = from
    .clone()
    .add(4, 'day')
    .endOf('day');

  return [newFrom, newTo];
};
